import * as ZapparThree from '@zappar/zappar-threejs'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import Experience from '.'

const MIN_ZOOM = 0.002
const MAX_ZOOM = 0.03

export default class Camera {
  private experience = new Experience()

  public zapparCamera!: ZapparThree.Camera
  public controls!: OrbitControls
  public perspectiveCamera!: THREE.PerspectiveCamera
  public orthoCamera!: THREE.OrthographicCamera
  public perpectiveCamQuaternion = new THREE.Quaternion()

  private state = false

  constructor() {
    this.setCameras()
    this.setControls()
  }

  private setCameras() {
    this.zapparCamera = new ZapparThree.Camera()
    this.zapparCamera.backgroundTexture.encoding = THREE.sRGBEncoding

    this.orthoCamera = new THREE.OrthographicCamera(
      -window.innerWidth / 2,
      window.innerWidth / 2,
      window.innerHeight / 2,
      -window.innerHeight / 2,
      1,
      10
    )
    this.orthoCamera.position.z = 10

    this.perspectiveCamera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      1,
      1000
    )
    this.perspectiveCamera.position.z = 0.01
    this.perspectiveCamera.position.x = 0.01

    this.experience.scene.add(this.perspectiveCamera)
  }

  public resetPerspectiveCamQuaternion() {
    this.controls?.reset()
    this.perspectiveCamera.quaternion.copy(this.perpectiveCamQuaternion)
  }

  public controlsEnabled(value = true) {
    this.controls.enabled = value
  }

  private setControls() {
    this.controls = new OrbitControls(
      this.perspectiveCamera,
      this.experience.targetElement
    )

    // this.controls.minZoom = MIN_ZOOM
    // this.controls.maxZoom = MAX_ZOOM

    this.controls.minDistance = MIN_ZOOM
    this.controls.maxDistance = MAX_ZOOM

    this.controls.enabled = false

    this.controls.rotateSpeed = 2.0
    this.controls.zoomSpeed = -1 // Reverse zoom!
    this.controls.panSpeed = 0.8

    this.controls.enableKeys = false
    this.controls.enableDamping = true

    this.perpectiveCamQuaternion.copy(this.perspectiveCamera.quaternion)
  }

  public resize() {
    this.perspectiveCamera.aspect =
      this.experience.config.screen.width / this.experience.config.screen.height

    this.perspectiveCamera.updateProjectionMatrix()
  }

  public start(value = false) {
    this.state = value
    this.zapparCamera.start(value)
  }

  public reverse() {
    const value = !this.state
    this.state = value
    this.zapparCamera.start(value)
  }

  public update() {
    this.controls?.update()
    this.zapparCamera.updateFrame(this.experience.renderer.instance)
  }
}
